import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button, Select, MenuItem} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import Cookies from 'js-cookie';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {    
  const [open, setOpen] = React.useState(false);

  const [studentName, setStudentName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);

  const [sendOtpLoading, setSendOtpLoading] = React.useState(false);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  var vertical='top',horizontal='center';

	function hideAlert(){    
		setShowAlert(false);
	}

  React.useEffect(() => {
    setSendOtpLoading(false);
		// setStudentName("");
    // setMobile("");
	}, [open]);


  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function callApi(){

    if(!studentName || studentName.length<1){
			setShowAlert(true);
			setAlertMessage("Enter your name");			
			return false;
		}
		if(!mobile || mobile.length<1){
			setShowAlert(true);
			setAlertMessage("Enter mobile");			
			return false;	
		}

    if(email && email.length>0 && !validateEmail(email) ){
      setShowAlert(true);
      setAlertMessage("Email is not valid.");			
      return false;
    }
		
		if(studentName && mobile){
      
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
				}
			};
      
      setSendOtpLoading(true);
			const data = new FormData();
			data.append('mobile', mobile);
			axios.post(API_URL+'/app/sendotp', data, axiosHeader)
			.then((response) => {
        setSendOtpLoading(false);
				///console.log("RESPONSE RECEIVED: ", response); 
				if(response && response.data && response.data.responseTxt==="sent_otp"){					
					//alert(JSON.stringify(response.data));

          Cookies.set('guestsignup', JSON.stringify({'studentName':studentName,'mobile':mobile,'email':email,'token':response.data.obj.token}) ); 
					handleClose();
          props.reg(2);
					return false;
				}else{
					setShowAlert(true);
					setAlertMessage("Something wrong somewhere");			
					return false;
				}
			})
			.catch((error) => {
				//console.log("AXIOS ERROR: ", error);
			})
		}  
	}

  // function onEnter(event){
	// 	if(event.key === 'Enter'){
	// 		signup();
	// 	}
	// }
	function numberOnly(event){
		if (!/[0-9]/.test(event.key)) {
			event.preventDefault();
		} 
	}

  return (
    <>
      {/* <Button title={"Save "+testTypeLabel+" & Exit"} onClick={handleClickOpen} variant="contained" color="primary" >Save & Exit</Button> */}
      <Dialog fullWidth onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle onClose={handleClose}>

          {!window.navigator.onLine?<span style={{color:'#FF0000'}}>Alert</span>:<>Verify your details to see your test result</>} 
        </DialogTitle>

        <DialogContent dividers>
            <div className="dialogSubmitTestBox">
              {!window.navigator.onLine?
              <p style={{color:'#FF0000',fontWeight:'bold',minHeight:60, padding: 20}}>
                It seems, you are not connected to the internet.
              </p>
              :
              <>
              <Box>
                <TextField onChange={event => setStudentName(event.target.value)} value={studentName} placeholder={'Enter your name'} sx={{fontSize: 10}} fullWidth variant="outlined" />  

                <TextField onChange={event => setMobile(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={mobile} placeholder={'Enter your mobile (OTP would be sent)'} sx={{marginTop:1, fontSize: 10}} inputProps={{ maxLength: 10 }} fullWidth variant="outlined" />  

                <TextField onChange={event => setEmail(event.target.value)} value={email} placeholder={'Enter your email'} sx={{marginTop:1, fontSize: 10}} fullWidth variant="outlined" />  

              </Box>

              <Box mt={2}>
              {sendOtpLoading?
                <LoadingButton loading={sendOtpLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#f96d02',color:'#FFFFFF'}}  variant="contained" >Wait</LoadingButton>
                :<Button onClick={() => { callApi() }} variant="contained" style={{backgroundColor:'#008000',color:'#FFFFFF'}} >Send OTP</Button>
              }
              </Box>

                           
              {/* <Button onClick={() => { backToSelectTest() }} style={{marginRight:20}} size="small" variant="outlined" >Cancel Test</Button> */}
              </>
              }
            </div>
        </DialogContent>

        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

      </Dialog>
    </>
  );

});

export default CustomizedDialogs;
